import { TopBar } from "@/components/layout";
import SitesMapTable from "@/components/SitesMapTable";

const SiteMapPage = () => {
  return (
    <>
      <TopBar title="Mapa Stron" />
      <div className="flex-1 overflow-auto p-6">
        <SitesMapTable />
      </div>
    </>
  );
};

export default SiteMapPage;
